import store, { subscribe } from 'shared/store'
import { actionNames } from 'shared/store/ducks/userSession'
import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'
import { ARIA_HIDDEN } from 'views/assets/scripts/consts'

import buildClientAPI from 'views/providers/clientAPI'
import { HIDE_MODAL } from 'shared/store/ducks/events'
import { TARGET_FEATURE_CODE_FIELD } from 'shared/consts/formFields'

import { LOGIN_MODAL_ID } from 'views/consts'

const NotePadService = isPim => {
  const { clientFockService } = buildClientAPI()
  return {
    addNotepad: (pzn, options) =>
      isPim
        ? clientFockService.addProductToNotepad(pzn)
        : clientFockService.addProductToWishList(options),

    removeNotepad: (pzn, options) =>
      isPim
        ? clientFockService.removeProductFromNotepad(pzn)
        : clientFockService.deleteProductFromWishList(options),
    getNotepad: pzn => clientFockService.fetchProductFromNotepad(pzn)
  }
}

const setTargetFeatureValue = () => {
  const inputs = document.getElementsByName(TARGET_FEATURE_CODE_FIELD)
  inputs.forEach(input => {
    input.value = 'notepad'
  })
  return () => {
    inputs.forEach(input => {
      input.value = ''
    })
  }
}

const wishList = async userSession => {
  const SELECTOR_WISHLIST_WRAPPER =
    '[data-clientside-hook~="o-BuyBoxWishList__wrapper"]'
  const SELECTOR_WISHLIST_BUTTON =
    '[data-clientside-hook~="o-BuyBoxWishList__button"]'
  const SELECTOR_WISHLIST_HEART_ICON =
    '[data-clientside-hook~="o-BuyBoxWishList__heart-icon"]'
  const SELECTOR_WISHLIST_HEART_FILLED_ICON =
    '[data-clientside-hook~="o-BuyBoxWishList__heartFilled-icon"]'
  const ADD_TO_WISHLIST_TOOLTIP =
    '[data-clientside-hook~="add-to-wishlist-tooltip"]'
  const ADD_TO_WISHLIST_TOOLTIP_TEXT =
    '[data-clientside-hook~="add-to-wishlist-tooltip-text"]'

  const wishlistWrapper = document.querySelector(SELECTOR_WISHLIST_WRAPPER)
  if (!wishlistWrapper) {
    return
  }
  const wishListLink = wishlistWrapper.querySelector(SELECTOR_WISHLIST_BUTTON)

  const tooltipTextContainer = document.querySelector(ADD_TO_WISHLIST_TOOLTIP)
  const tooltipText = document.querySelector(ADD_TO_WISHLIST_TOOLTIP_TEXT)
  /** @type HTMLElement */
  const heartIcon = document.querySelector(SELECTOR_WISHLIST_HEART_ICON)
  /** @type HTMLElement */
  const heartFilledIcon = document.querySelector(
    SELECTOR_WISHLIST_HEART_FILLED_ICON
  )

  const { product, isLoggedIn } = userSession

  const queryParams = new URL(document.location).searchParams
  const targetFeatureCode = queryParams.get(TARGET_FEATURE_CODE_FIELD)

  if (!isLoggedIn) {
    let unsetTargetFeatureValue

    wishListLink.addEventListener('click', () => {
      unsetTargetFeatureValue = setTargetFeatureValue()
    })

    subscribe.after(HIDE_MODAL, ({ modalName }) => {
      if (modalName === LOGIN_MODAL_ID) {
        if (typeof unsetTargetFeatureValue === 'function') {
          unsetTargetFeatureValue()
        }
      }
    })
    return
  }

  const {
    pageProperties: { pzn, category, isPim }
  } = store.getPublicRuntimeConfig()

  const options = {
    params: {
      productCode: pzn,
      categoryCode: category
    }
  }

  let onNotepad
  if (isPim) {
    try {
      await NotePadService(isPim).getNotepad(pzn)
      onNotepad = true
    } catch (e) {
      onNotepad = false
    }
  } else {
    onNotepad = product.onNotepad
  }

  // to disable multiple click
  let isFetching = false

  const toggleIcons = isInWishlist => {
    toggleBoolStringAttr(heartFilledIcon, ARIA_HIDDEN, isInWishlist)
    toggleBoolStringAttr(heartIcon, ARIA_HIDDEN, !isInWishlist)
  }

  const updateNotepad = async () => {
    if (isFetching || !isLoggedIn) return
    isFetching = true
    try {
      if (onNotepad) {
        // product is already in wishlist
        await NotePadService(isPim).removeNotepad(pzn, options)
        onNotepad = false
        toggleIcons(onNotepad)
      } else {
        // product is not in wishlist
        await NotePadService(isPim).addNotepad(pzn, options)
        onNotepad = true
        toggleIcons(onNotepad)
      }
    } catch (e) {
      // show tooltip only in the case of failure
      toggleBoolStringAttr(tooltipText, ARIA_HIDDEN, null)
    } finally {
      isFetching = false
    }
  }

  if (targetFeatureCode === 'notepad' && !onNotepad) {
    await NotePadService(isPim).addNotepad(pzn, options)
    onNotepad = true
    toggleIcons(onNotepad)
  }

  if (onNotepad) {
    toggleIcons(true)
  }

  wishListLink.addEventListener('click', () => {
    toggleBoolStringAttr(tooltipTextContainer, ARIA_HIDDEN, true)
  })

  wishListLink.addEventListener('click', updateNotepad)
}

export default () => {
  subscribe.after.once(actionNames.setUserSession, ({ userSession }) => {
    wishList(userSession)
  })
}
